import React, { useState } from 'react';
import { enterKeyHandler, escapeKeyHandler } from 'window-utils/lib/keyHandlerUtils';

const style = require('./TaskListSwitcher.scss');

export const TaskListSwitcher = props => {
    const [isListVisible, setListVisibility] = useState(false);
    const folderList: any[] = props.folderList;
    const { selectedFolderName, onSwitchFolder } = props;

    function determineKeyEvent(e) {
        enterKeyHandler(() => toggleList())(e);
        escapeKeyHandler(() => {
            e.preventDefault();
            closeList();
        })(e);
    }

    function determineKeyEventForListItem(e, Name, Id) {
        enterKeyHandler(() => onListClick(Name, Id))(e);
        escapeKeyHandler(() => {
            e.preventDefault();
            closeList();
        })(e);
    }

    function toggleList() {
        setListVisibility(!isListVisible);
    }

    function closeList() {
        setListVisibility(false);
    }

    function onListClick(foldername: string, folderId: string) {
        if (foldername !== selectedFolderName) {
            onSwitchFolder(foldername, folderId);
        }
        setListVisibility(false); // hide list
    }

    return (
        <>
            <div
                className={style.heading}
                role="option"
                aria-haspopup="true"
                tabIndex={0}
                onClick={toggleList}
                onKeyDown={determineKeyEvent}>
                {selectedFolderName}
                <span className={style.chevronSpan} />
            </div>
            <div className={style.listContainer}>
                {isListVisible &&
                    folderList.map(x => (
                        <div
                            key={x.name}
                            className={style.folderListItem}
                            role="option"
                            tabIndex={0}
                            aria-label={x.Name}
                            onKeyDown={e => determineKeyEventForListItem(e, x.Name, x.Id)}
                            onClick={() => onListClick(x.Name, x.Id)}>
                            {x.Name}
                        </div>
                    ))}
            </div>
        </>
    );
};
